import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS,
  GET_LIQUIDATION_DIFFERENCE_REASONS,
  CLEAR_LIQUIDATION_DIFFERENCE_REASONS,
  FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASON,
  GET_LIQUIDATION_DIFFERENCE_REASON,
  CLEAR_LIQUIDATION_DIFFERENCE_REASON,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_LIQUIDATION_DIFFERENCE_REASONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_LIQUIDATION_DIFFERENCE_REASONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASON:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_LIQUIDATION_DIFFERENCE_REASON:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_LIQUIDATION_DIFFERENCE_REASON:
            return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
